module.exports = __webpack_public_path__ + "static/img/jeans_right_red.411a0c19.png";